import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Pagination, PaginationItem, PaginationLink, Alert, Input } from "reactstrap";
import { getTranslate } from "react-localize-redux";
import Select from "react-select";
import { actions } from "react-redux-form";
import moment from "moment";
import { SearchPanel } from "../AppLayout/SearchPanel/SearchPanel";
import { DocumentsGrid } from "./DocumentsGrid";
import { documentActions, configActions } from "../../../redux/actions";
import { formatSizeUnits, getDocumentsParams } from "../../../utils";
import "./Documents.scss";

class Documents extends React.Component {
  handlePageClick = (event) => {
    event.preventDefault();
    const {
      dispatch,
      translate,
      documents,
      docSearch,
      isExternalUser,
      externalCustomerId,
      isSender,
    } = this.props;
    var _pageNum = Number(event.target.id);
    if (_pageNum > 0) {
      if (documents.listFromFileLoaded) {
        var _searchParams = getDocumentsParams(
          { ...docSearch },
          isExternalUser,
          externalCustomerId,
          isSender
        );

        let _params = Object.assign({}, documents.params, _searchParams, {
          PageNumber: _pageNum,
        });

        dispatch(documentActions.setDocumentListParams("PageNumber", _pageNum));
        dispatch(documentActions.getListFromFile(_params));
      } else {
        dispatch(actions.change("docSearch.PageNumber", _pageNum));
        dispatch(
          documentActions.getAll(
            getDocumentsParams(
              { ...docSearch, PageNumber: _pageNum },
              isExternalUser,
              externalCustomerId,
              isSender
            ),
            `${translate("LoadingDocuments")}...`
          )
        );
      }
      dispatch(configActions.resetDocsActiveTab());
      dispatch(configActions.resetDocsInstances());
      dispatch(configActions.resetDocumentDeliveryData());
    }
  };

  handleFirstClick = (event) => {
    event.preventDefault();
    const {
      dispatch,
      translate,
      documents,
      docSearch,
      isExternalUser,
      externalCustomerId,
      isSender,
    } = this.props;
    if (documents.listFromFileLoaded) {
      var _searchParams = getDocumentsParams(
        { ...docSearch },
        isExternalUser,
        externalCustomerId,
        isSender
      );

      let _params = Object.assign({}, documents.params, _searchParams, {
        PageNumber: 1,
      });
      dispatch(documentActions.setDocumentListParams("PageNumber", 1));
      dispatch(documentActions.getListFromFile(_params));
    } else {
      dispatch(actions.change("docSearch.PageNumber", 1));
      dispatch(
        documentActions.getAll(
          getDocumentsParams(
            { ...docSearch, PageNumber: 1 },
            isExternalUser,
            externalCustomerId,
            isSender
          ),
          `${translate("LoadingDocuments")}...`
        )
      );
    }
    dispatch(configActions.resetDocsActiveTab());
    dispatch(configActions.resetDocsInstances());
    dispatch(configActions.resetDocumentDeliveryData());
  };
  handleParamChange = (paramName, paramValue) => {
    this.props.dispatch(actions.change(`docSearch.${paramName}`, paramValue));
  };

  handleSearchClick = (event) => {
    if (event) event.preventDefault();
    const {
      dispatch,
      translate,
      documents,
      docSearch,
      isExternalUser,
      externalCustomerId,
      isSender,
    } = this.props;
    if (documents.listFromFileLoaded) {
      var _searchParams = getDocumentsParams(
        { ...docSearch },
        isExternalUser,
        externalCustomerId,
        isSender
      );
      var _additionalParams = {
        FileId: documents.params["FileId"],
      };
      if (documents.params["fidfs"]) {
        _additionalParams["fidfs"] = documents.params["fidfs"];
      }
      if (documents.params["FileChannel"]) {
        _additionalParams["FileChannel"] = documents.params["FileChannel"];
      }
      if (documents.params["noMData"]) {
        _additionalParams["noMData"] = documents.params["noMData"];
      }

      let _params = Object.assign({}, _searchParams, _additionalParams);
      dispatch(documentActions.getListFromFile(_params));
    } else {
      dispatch(actions.change("docSearch.PageNumber", 1));
      dispatch(configActions.resetDocsActiveTab());
      dispatch(configActions.resetDocsInstances());
      dispatch(configActions.resetDocumentDeliveryData());
      dispatch(
        documentActions.getAll(
          getDocumentsParams(
            { ...docSearch, PageNumber: 1 },
            isExternalUser,
            externalCustomerId,
            isSender
          ),
          `${translate("LoadingDocuments")}...`
        )
      ).then((data) => {
        if (data.documents && data.documents.length === 0) {
          dispatch(actions.change(`docSearch.showMoreHeight`, "auto"));
          dispatch(actions.change(`docSearch.moreArrowIcon`, "fa-chevron-up"));
          dispatch(
            actions.change(
              `docSearch.toggleBtnTitle`,
              "Hide advanced search options"
            )
          );
        }
      });
    }
  };

  onAdditionalOptionChange = (data, name) => {
    if (!name) {
      return null;
    }

    if (!data || !data.value) {
      const {
        [name]: paramToRemove,
          ...remainder
      } = this.buildParamObject();

      return this.dispatchSearchRequest(remainder);
    }

    const { value } = data;
    const result = {
      ...this.buildParamObject(),
      [name]: value
    };

    this.dispatchSearchRequest(result);
  };

  buildParamObject() {
    const {
      documents,
      docSearch,
      isExternalUser,
      externalCustomerId,
      isSender,
    } = this.props;
    const _searchParams = getDocumentsParams(
        { ...docSearch },
        isExternalUser,
        externalCustomerId,
        isSender
    );

    return {
      ...documents.params,
      ..._searchParams
    }
  }

  dispatchSearchRequest(params) {
    const { dispatch } = this.props;

    dispatch(documentActions.getListFromFile(params));
  }

  onListFromFileDismiss = () => {
    this.props.dispatch(documentActions.clearDocuments());
    this.props.history.push("/documents");
  };

  isOldDocument = (doc) => {
    const arrivalTime = moment.utc(doc.fileArrivalTs, moment.ISO_8601);
    let _activeFileLimitDate = new Date();
    _activeFileLimitDate.setDate(
      _activeFileLimitDate.getDate() - (window.ActiveFileMaxAgeDays || 2)
    );
    return arrivalTime.toDate().getTime() < _activeFileLimitDate.getTime();
  };

  componentDidMount() {
    const {
      dispatch,
      documents,
      defaultSize,
      isExternalUser,
      externalCustomerId,
      isSender,
      location,
    } = this.props;
    let _searchQry = location.search;
    if (_searchQry) {
      var qs = require("qs");
      let queryObj = qs.parse(_searchQry.substr(1));
      if (
        queryObj["DocUniqueId"] &&
        !documents.cleared &&
        !documents.error &&
        !documents.loading &&
        !documents.withUniqueId
      ) {
        let params = {
          PageNumber: 1,
          Size: defaultSize || 20,
          DocUniqueId: queryObj["DocUniqueId"],
        };
        // Force setting customerId for subuser if present in the url
        if (isExternalUser) {
          params["CustomerId"] = externalCustomerId;
        }
        if (queryObj["CustomerId"]) {
          params["CustomerId"] = queryObj["CustomerId"];
          if (
            !isExternalUser ||
            queryObj["CustomerId"] !== externalCustomerId
          ) {
            dispatch(
              actions.change("docSearch.CustomerId", queryObj["CustomerId"])
            );
          }
        }
        dispatch(configActions.resetDocsActiveTab());
        dispatch(configActions.resetDocsInstances());
        dispatch(configActions.resetDocumentDeliveryData());
        dispatch(documentActions.getListFromFile(params, true));
      } else if (
        queryObj["file_event_id"] &&
        !documents.cleared &&
        !documents.error &&
        !documents.loading &&
        !documents.listFromFileLoaded
      ) {
        var _searchParams = getDocumentsParams(
          {},
          isExternalUser,
          externalCustomerId,
          isSender
        );
        let params = {
          ..._searchParams,
          PageNumber: 1,
          Size: defaultSize || 20,
          FileId: queryObj["file_event_id"],
        };

        if (queryObj["fidfs"]) {
          params["fidfs"] = queryObj["fidfs"];
        }
        // Force setting customerId for subuser if present in the url
        if (isExternalUser) {
          params["CustomerId"] = externalCustomerId;
        }
        if (queryObj["CustomerId"]) {
          params["CustomerId"] = queryObj["CustomerId"];
          if (
            !isExternalUser ||
            queryObj["CustomerId"] !== externalCustomerId
          ) {
            dispatch(
              actions.change("docSearch.CustomerId", queryObj["CustomerId"])
            );
          }
        }
        if (queryObj["channel"]) params["FileChannel"] = queryObj["channel"];
        dispatch(configActions.resetDocsActiveTab());
        dispatch(configActions.resetDocsInstances());
        dispatch(configActions.resetDocumentDeliveryData());
        dispatch(documentActions.getListFromFile(params));
      }
    }
  }

  render() {
    const {
      documents,
      docSearch,
      translate,
      isExternalUser,
      isSender,
      externalCustomerId,
      handleOpenFullEventClick,
      handleOpenEndpointsClick,
      handleOpenDocsBucketClick,
      handleShowParametersClick,
    } = this.props;
    let PageNumber = 0;
    if (documents.listFromFileLoaded) {
      PageNumber = documents.params.PageNumber;
    } else {
      PageNumber = docSearch.PageNumber;
    }

    let prev = PageNumber > 0 ? PageNumber - 1 : 0;
    let last = documents.TotalPages;

    // Logic for displaying page numbers
    let pageNumbers = [];
    // get window of max 5
    let start = last > 4 ? last - 4 : 1;
    for (let i = start; i <= last; i++) {
      pageNumbers.push(i);
    }

    let filesummary = documents.filesummary || {};
    let docChannelOpts = (filesummary.channels || []).map((item) => {
      return { value: item, label: item };
    });

    return (
      <div id="documents_view">
        <div className="w-100 top_search" style={{ textAlign: "center" }}>
          <SearchPanel
            view="documentsView"
            docListFromFileLoaded={documents.listFromFileLoaded}
            searchParams={docSearch}
            isExternalUser={isExternalUser}
            isSender={isSender}
            handleParamChange={this.handleParamChange}
            onSearchClick={(params_) => {
              this.handleSearchClick(params_);
            }}
          />
        </div>
        <div
          id="documents_content"
          className="content_block fill col-lg-12 col-md-12 col-sm-12 col-xs-12"
          style={{ padding: "0", width: "100%" }}
        >
          {documents.listFromFileLoaded && (
            <Alert
              color="info"
              style={{ margin: 0 }}
              isOpen={documents.listFromFileLoaded}
              toggle={this.onListFromFileDismiss}
            >
              <div className="row">
                <div className="col-lg-12 col-md-6 col-sm-6 col-xs-6">
                  <div
                    className="text-left form-inline"
                    style={{ padding: "5px 0" }}
                    id="documents_channels_block"
                  >
                    {!isExternalUser && (
                      <div className="col-lg-4 col-md-5 col-sm-6 form-group">
                        <label htmlFor="filter_channel_docs">
                          {translate("Channel")}&nbsp;&nbsp;
                        </label>
                        <Select
                            name="customerComboBox"
                            value={documents.params.FileChannel}
                            placeholder={translate("SelectChannel")}
                            onChange={ (e) => this.onAdditionalOptionChange(e, 'FileChannel') }
                            options={docChannelOpts}
                        />
                        <label htmlFor="noMData">
                          {translate("ShowOnlyIncomplete")}&nbsp;&nbsp;
                          <Input
                              readOnly
                              id="noMData"
                              name="noMData"
                              type="checkbox"
                              checked={ documents.params.noMData }
                              onChange={
                                ({
                                   target: {
                                     checked
                                   }
                                 }) => this.onAdditionalOptionChange({ value: checked }, 'noMData')
                              }
                          />
                        </label>
                      </div>
                    )}
                    <div
                      className={
                        !isExternalUser
                          ? "col-lg-8 col-md-7 col-sm-6 form-group form-inline"
                          : ""
                      }
                      style={{ display: "block" }}
                      id="doc_info"
                    >
                      <div>
                        <span>
                          <strong translate="FileName">
                            {translate("FileName")}:{" "}
                          </strong>
                          <span>{filesummary.filename}</span>
                        </span>
                        <span className="event-header-separator"> / </span>
                        <span>
                          <strong translate="ArrivalTime">
                            {translate("ArrivalTime")}:{" "}
                          </strong>
                          <span>
                            {filesummary.arrivaltime
                              ? moment
                                  .utc(filesummary.arrivaltime, moment.ISO_8601)
                                  .format("DD-MM-YYYY HH:mm:ss")
                              : "n/a"}
                          </span>
                        </span>
                        <span className="event-header-separator"> / </span>
                        <span>
                          <strong translate="FileSize">
                            {translate("FileSize")}:{" "}
                          </strong>
                          <span>{formatSizeUnits(filesummary.size)}</span>
                        </span>
                      </div>
                      <div>
                        <span>
                          <strong>Actual documents in the file: </strong>
                          <span>{filesummary.adc}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Alert>
          )}
          <div id="documents_grids">
            {documents.items && (
              <DocumentsGrid
                docs={documents.items}
                listFromFileLoaded={documents.listFromFileLoaded}
                isExternalUser={isExternalUser}
                externalCustomerId={externalCustomerId}
                isSender={isSender}
                docSearch={docSearch}
                handleOpenFullEventClick={handleOpenFullEventClick}
                handleOpenEndpointsClick={handleOpenEndpointsClick}
                handleOpenDocsBucketClick={handleOpenDocsBucketClick}
                handleShowParametersClick={handleShowParametersClick}
              />
            )}
          </div>
          {documents.items && documents.items.length > 0 && (
            <div className="d-flex justify-content-center grid-footer">
              {/* <FormGroup className="mb-2 mr-sm-2 mb-sm-0 form-inline paging-count-select" /> */}
              <Pagination>
                <PaginationItem>
                  {prev === 0 ? (
                    <PaginationLink disabled>
                      <small>
                        <span className="fa fa-fast-backward" />
                      </small>
                      &nbsp;{translate("First")}
                    </PaginationLink>
                  ) : (
                    <PaginationLink
                      onClick={this.handleFirstClick}
                      id={prev}
                      href={prev}
                    >
                      <small>
                        <span className="fa fa-fast-backward" />
                      </small>
                      &nbsp;{translate("First")}
                    </PaginationLink>
                  )}
                </PaginationItem>
                <PaginationItem>
                  {prev === 0 ? (
                    <PaginationLink disabled>
                      <small>
                        <span className="fa fa-backward" />
                      </small>
                      &nbsp;{translate("Prev")}
                    </PaginationLink>
                  ) : (
                    <PaginationLink
                      onClick={this.handlePageClick}
                      id={prev}
                      href={prev}
                    >
                      <small>
                        <span className="fa fa-backward" />
                      </small>
                      &nbsp;{translate("Prev")}
                    </PaginationLink>
                  )}
                </PaginationItem>
                {pageNumbers.map((number, i) => (
                  <Pagination key={i}>
                    <PaginationItem
                      active={
                        pageNumbers.indexOf(PageNumber) === i ? true : false
                      }
                    >
                      <PaginationLink
                        onClick={this.handlePageClick}
                        href={number}
                        key={number}
                        id={number}
                      >
                        {number}
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                ))}

                <PaginationItem>
                  {PageNumber >= last ? (
                    <PaginationLink disabled>
                      {translate("Next")}&nbsp;
                      <small>
                        <span className="fa fa-forward" />
                      </small>
                    </PaginationLink>
                  ) : (
                    <PaginationLink
                      onClick={this.handlePageClick}
                      id={pageNumbers[pageNumbers.indexOf(PageNumber) + 1]}
                      href={pageNumbers[pageNumbers.indexOf(PageNumber) + 1]}
                    >
                      {translate("Next")}&nbsp;
                      <small>
                        <span className="fa fa-forward" />
                      </small>
                    </PaginationLink>
                  )}
                </PaginationItem>
              </Pagination>
              {/* <div className="grid-paging-info" style={{ margin: "0px 15px" }}>
                Version: {window.NTT && window.NTT.version}
              </div> */}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { documents, docSearch, locale, config } = state;
  const { docsActiveTabs, docsInstances } = config;
  return {
    documents,
    hiddenColumns: documents.hiddenColumns,
    docSearch,
    docsActiveTabs,
    docsInstances,
    translate: getTranslate(locale),
    tagsIcons: config.tagsIcons,
  };
}

const connectedDocuments = connect(mapStateToProps)(withRouter(Documents));
export { connectedDocuments as Documents };
